import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Translate, {t} from "../../../../components/Translate";
import {updateTicketDescriptionAndAssignedUser} from "../../../../services/company/api";
import SilverButton from "../../../../components-new/buttons/SilverButton";
import BlueButton from "../../../../components-new/buttons/BlueButton";
import DropdownSelect from "../../../../components-new/DropdownSelect";
import config from "../../../../config";
import Input from "../../../../components-new/Input";


const styles = {
    overlay: {
        backgroundColor: config.modalBackgroundColor,
        zIndex: '2000',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    content: {
        backgroundColor: '#fff',
        color: 'rgb(4, 62, 92)',
        padding: '40px',
        borderRadius: '20px',
        maxWidth: '500px',
        width: '100%',
        boxSizing: 'border-box',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
        textAlign: 'center',
        transition: 'opacity 0.3s ease-out, transform 0.3s ease-out',
        animation: 'fadeIn 0.3s ease-out',
    },
    title: {
        color: '#09183A',
        fontSize: '22px',
        marginBottom: '30px',
        textAlign: 'center',
    },
    infoRow: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '20px',
        alignItems: 'center',
    },
    _infoRow: {
        marginBottom: '20px',
        padding: '20px',
        borderRadius: '10px',
        backgroundColor: 'rgb(241, 241, 241)',
        textAlign: 'left',
    },
    label: {
        fontWeight: 'bold',
        color: '#09183A',
        marginBottom: '5px',
    },
    value: {
        color: '#5a5a5a',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap',
    },
    select: {
        padding: '10px',
        borderRadius: '10px',
        border: '1px solid #103c5b',
        backgroundColor: '#fff',
        color: '#103c5b',
        width: '100%',
        fontSize: '14px',
        marginLeft: '20px'
    },
    textarea: {
        width: '100%',
        minHeight: '100px',
        padding: '10px',
        borderRadius: '10px',
        border: '1px solid #103c5b',
        color: '#103c5b',
        fontSize: '14px',
        resize: 'vertical',
    },
    buttonsWrapper: {
        textAlign: 'center',
        marginTop: '20px',
    },
    closeBtn: {
        backgroundColor: '#103c5b',
        marginRight: '10px',
        marginBottom: '10px',
        border: 'none',
        cursor: 'pointer',
        color: '#fff',
        padding: '12px 24px',
        borderRadius: '10px',
        width: '160px',
        fontSize: '16px',
        boxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
    },
    chatHistoryBtn: {
        backgroundColor: '#103c5b',
        border: 'none',
        cursor: 'pointer',
        color: '#fff',
        padding: '12px 24px',
        borderRadius: '10px',
        width: '240px',
        marginLeft: '10px',
        fontSize: '16px',
        boxShadow: '2px 2px 5px 0px rgba(24, 62, 153, 0.17)',
    }
};


const TicketPopup = ({
                         isOpen,
                         onClose,
                         content,
                         user,
                         users,
                         updatePopupContent,
                         addNotification
                     }) => {
    const [assignedUser, setAssignedUser] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (content) {
            setAssignedUser(content.assignedUser ? content.assignedUser.platformId : '');
            setDescription(content.description || '');
        }
    }, [content]);

    if (!isOpen) return null;

    const handleUserChange = (e) => {
        setAssignedUser(e.target.value);
    };

    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
    };

    const handleSaveTicket = () => {
        const ticketId = content.id;
        updateTicketDescriptionAndAssignedUser(ticketId, description, assignedUser).then(data => {
            updatePopupContent(data);
            addNotification('saved', config.notificationLevels.info)
        });
    }

    return (
        <div style={styles.overlay}>
            <div style={styles.content}>
                <h2 style={styles.title}>{content.subject}</h2>
                <div style={styles.infoRow}>
                    <span style={styles.label}><Translate text="category"/>:</span>
                    <span style={styles.value}>{content.categoryName}</span>
                </div>
                <div style={styles.infoRow}>
                    <span style={styles.label}><Translate text="priority"/>:</span>
                    <span style={styles.value}>{t({text: content.priority, user})}</span>
                </div>
                <div style={styles.infoRow}>
                    <span style={styles.label}><Translate text="user"/>:</span>
                    <span
                        style={styles.value}>{content.conversation.user.firstName + " " + content.conversation.user.lastName}</span>
                </div>
                <div style={styles.infoRow}>
                    <span style={styles.label}><Translate text="assignee"/>:</span>
                    <DropdownSelect
                        options={users.map(user => ({
                            value: user.id,
                            label: `${user.firstName} ${user.lastName}`,
                        }))}
                        selectedValue={assignedUser}
                        onChange={(newValue) => handleUserChange({target: {value: newValue}})}
                        renderLabel={(value) => {
                            const selectedUser = users.find(user => user.id === value);
                            return selectedUser ? `${selectedUser.firstName} ${selectedUser.lastName}` : '';
                        }}
                        style={styles.select}
                        placeholder={t({text: "selectUser", user})}
                    />
                </div>

                <br/>
                <br/>
                <div style={styles._infoRow}>
                    <span style={styles.label}><Translate text="description"/>:</span>
                    <Input
                        isTextarea={true}
                        style={{resize: 'none'}}
                        maxLength={5000}
                        value={description}
                        onChange={handleDescriptionChange}
                    />
                </div>
                <div style={styles.buttonsWrapper}>
                    <SilverButton styles={{marginRight: '20px'}} type={'button'} onClick={onClose} width={'130px'}
                                  children={<Translate text="close"/>}/>
                    <BlueButton type={'button'}
                                onClick={() => {
                                    onClose();
                                    handleSaveTicket();
                                }}
                                width={'150px'} children={<Translate text="save"/>}/>
                    <br/>
                </div>
            </div>
        </div>
    );
};

TicketPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    content: PropTypes.object,
    user: PropTypes.object.isRequired,
    users: PropTypes.array.isRequired
};


export default TicketPopup;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/my-history/TicketPopup.jsx